<template>
  <div
    :meta-error="metaError"
    :class="['input-component w-full relative', extraClass, isActive ? 'is-active' : '', error ? 'is-error' : '']"
  >
    <div class="relative input input-field">
      <label v-if="isFocused || inputValue" :for="computedId" class="text-xs text-au_gray-700 cursor-text mb-auto absolute top-1 left-4">{{ label }}</label>

      <input
        :id="computedId"
        v-model="inputValue"
        :placeholder="isFocused ? undefined : placeholder"
        :name="name"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :aria-label="label"
        type="text"
        class="w-full h-12 rounded px-4 text-black border-0 appearance-none outline-none"
        :class="[
          (isFocused || inputValue) && 'pt-4',
          variant !== 'modern' && !disabled && 'bg-au_gray-100 placeholder-au_blue-500',
          variant === 'modern' && !disabled && 'bg-white placeholder-au_gray-700 focus:border-au_gray-200',
          inputClass,
          disabled && 'bg-au_gray-200',
        ]"
        @focus="onFocus"
        @blur="onBlur"
        @paste="onPaste"
        @change="onChange"
      >
      <span
        v-if="optional"
        class="absolute top-0 bottom-0 right-0 flex items-center mr-3 text-xs leading-none text-gray-600 optional"
      >
        {{ tr('components.flightVoucher.form.optional') }}
      </span>
    </div>

    <p v-if="error">
      <span
        class="text-au_error text-xs"
        :class="[
          variant !== 'modern' ? 'leading-none' : '',
          variant === 'modern' ? 'inline-flex px-2 py-1 mt-2 leading-normal input-error bg-au_error-100' : '',
        ]"
      >{{ error }}</span>
    </p>
  </div>
</template>

<script>
import TextInput from '~components/shared/text-input'

export default TextInput.extend({
  props: {
    variant: {
      type: String,
      default: 'classic',
    },
  },
})
</script>

<style lang="scss" scoped>
  .input-component {
    &.is-optional {
      input {
        padding-right: 75px; /* let's assume that word "optional" has that width in all translations */
      }
    }

  }

  .input-field {
    &:focus-within {
      position: relative;

      &::after {
        pointer-events: none;
        content: '';
        position: absolute;
        left: -6px;
        top: -6px;
        width: calc(100% + 12px);
        height: calc(100% + 12px);
        border: 1px solid black;
      }
    }
  }

  .uppercase.placeholder-normal-case {
    &::-webkit-input-placeholder {
      /* WebKit browsers */
      text-transform: none;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      text-transform: none;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      text-transform: none;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      text-transform: none;
    }

    &::placeholder {
      /* Recent browsers */
      text-transform: none;
    }
  }
</style>
